var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-slider relative flex justify-center" },
    [
      _c(
        "button",
        {
          staticClass:
            "view-all-images-button bg-black lg:bg-white block text-center text-white lg:text-black transition-colors border border-black lg:border-white rounded-8 font-extraBold py-[20px] px-[22px] uppercase text-18",
          on: {
            click: function($event) {
              _vm.index = 0
            }
          }
        },
        [_vm._v("\n        Bekijk alle foto's\n    ")]
      ),
      _vm._v(" "),
      _c("vue-gallery-slideshow", {
        attrs: { images: _vm.images, index: _vm.index },
        on: {
          close: function($event) {
            _vm.index = null
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }